"use client"
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

const GoogleAutocomplete = ({
    children,
    onChange,
    manually,
    defaultValue,
    icon,
    label,
    InputClassName,
    LabelClassName,
    autocompleteContainerClass,
    callback
}) => {

    const [address, setAddress] = useState("");
    const handleChangeAddress = (newAddress, data) => {
        setAddress(newAddress);
        if (onChange) {
            onChange(newAddress);
        }
    };
    const handleSelectAddress = (newAddress, placeId, suggestion) => {
        setAddress(newAddress);
        geocodeByAddress(newAddress)
            .then((results) => {
                if (callback) {
                    callback(results[0]);
                }
                return getLatLng(results[0])
            })
            .then((latLng) => console.log("Success", latLng))
            .catch((error) => console.error("Error", error));
    };

    useEffect(() => {
        if (defaultValue) {
            setAddress(defaultValue);
        }
    }, [defaultValue])


    
    return (
        <PlacesAutocomplete
            value={address}
            onChange={handleChangeAddress}
            onSelect={handleSelectAddress}
        >
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div className='relative'>
                    <div className="relative">
                        <input
                            {...getInputProps({
                                id: "googleaddress",
                                placeholder: "",
                                // className: {`location-search-input floating-input peer pl-10 ${InputClassName}`}
                                className: `location-search-input border-clr border-[1px] px-3.5 pt-5 pb-1 min-h-[54px] block w-full 
                                placeholder:text-input1 text-t2 sm:text-lg text-base rounded-[6px] focus-visible:outline-none 
                                focus-visible:border-blue peer pl-10 ` + InputClassName
                            })}
                        />
                        <label htmlFor="googleaddress" className={`
                        absolute text-input1 peer-placeholder-shown:sm:text-lg text-base peer-placeholder-shown:font-normal font-medium 
                        peer-focus:!font-medium peer-focus:!text-base duration-300 transform -translate-y-[0.9rem] top-[0.9rem] z-10 origin-[0] start-3.5  
                        peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-[0.9rem] 
                        rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto pointer-events-none pl-6 ${LabelClassName}`}>
                            {label}
                        </label>

                        <div className="absolute inset-y-0 end-0 flex items-center pr-3 pointer-events-none">
                            {icon}
                        </div>
                    </div>

                    <div className={`z-[999] autocomplete-dropdown-container absolute top-full w-full rounded-b-[3px] -mt-px ${autocompleteContainerClass}`}>
                        {/* {loading && <div>Loading...</div>} */}
                        {(suggestions?.length > 0)
                            ?
                            <>
                                {manually &&
                                
                                    <div className='suggestion-item '>
                                        <span>Don`t see your address? <a className='cursor-pointer hover:border-b-2'>Enter address manually</a></span>
                                    </div>
                                }
                                {_.map(suggestions, (suggestion,) => {
                                    const className = suggestion.active ? 'suggestion-item suggestion-item--active cursor-pointer' : 'suggestion-item cursor-pointer';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active ? {} : {};
                                    return (
                                        <div {...getSuggestionItemProps(suggestion, { className, style })} key={suggestion.description} >
                                            <span>{suggestion.description}</span>
                                        </div>
                                    );
                                })}
                            </>
                            :
                            <>
                                {children}
                            </>
                        }
                    </div>
                </div>
            )}
        </PlacesAutocomplete>

    );
};

export default GoogleAutocomplete;
